(function(app) {
    app.provider("marketingTrackerDataImportApi",
        [
            function() {
                this.$get = [
                    "marketingTrackerApiGateway",
                    function(marketingTrackerApiGateway) {
                        var service = {};

                        service.getDataImport = function(dataImportId) {
                            return marketingTrackerApiGateway.get("/DataImports/" + dataImportId);
                        };

                        service.getDataImports = function() {
                            return marketingTrackerApiGateway.get("/DataImports");
                        };

                        service.getDataConnectionId = function() {
                            return marketingTrackerApiGateway.get("/DataImports/ConnectionId");
                        };

                        service.getTypes = function() {
                            return marketingTrackerApiGateway.get("/DataImports/Types");
                        };

                        service.upload = function(dataImportType, file) {
                            return marketingTrackerApiGateway.postFile("/DataImports/Upload/" + dataImportType, file);
                        };

                        return service;
                    }
                ];
            }
        ]);
})(window.app); //jshint ignore:line